import { LinkList, ResponsiveImage } from '@sleepstation/components'
import { BreakingLayout } from '@sleepstation/components-layouts'
import propTypes from '@sleepstation/components-prop-types'
import { DIRECTION, LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { paddingV } from '@sleepstation/style-api-helpers'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Smallprint from './Smallprint'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const INFORMATION_STANDARD_LOGO = {
  src: `/images/information-standard-logo.svg`,
  alt: `Information Standard Logo`,
  aspectRatio: 277 / 150,
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(BreakingLayout).attrs({
  direction: [DIRECTION.VERTICAL, DIRECTION.HORIZONTAL],
  spacing: [LAYOUT_SPACING.MEDIUM, LAYOUT_SPACING.BETWEEN],
  align: LAYOUT_ALIGN.CENTER,
})`
  ${paddingV(0.75)}
`

const Inner = styled(BreakingLayout).attrs({
  direction: DIRECTION.VERTICAL,
  align: [LAYOUT_ALIGN.CENTER, LAYOUT_ALIGN.LEFT],
  spacing: LAYOUT_SPACING.MEDIUM,
})`
  position: relative;
`

const InformationStandardLink = styled(Link)`
  display: block;
  width: ${rem(93)};
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Lower = ({ legalPages, informationStandardPath }) => (
  <Layout>
    <Inner>
      {legalPages && (
        <LinkList
          pages={legalPages}
          direction={DIRECTION.HORIZONTAL}
          spacing={LAYOUT_SPACING.LARGE}
        />
      )}
      <Smallprint />
    </Inner>
    <InformationStandardLink to={informationStandardPath}>
      <ResponsiveImage {...INFORMATION_STANDARD_LOGO} />
    </InformationStandardLink>
  </Layout>
)

Lower.propTypes = {
  legalPages: propTypes.pages,
  informationStandardPath: PropTypes.string.isRequired,
}

Lower.defaultProps = {
  legalPages: undefined,
}

export default Lower
